module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-d749f9c3.png";